module.exports = __webpack_public_path__ + "assets/img/icon4.a5528d54.png";